import React from 'react';
import pt from 'prop-types';
import debounce from 'lodash/debounce';
import { Form, Field } from 'components/form';
import Modal from 'components/modal';
import { findPage, getPageUrl } from 'components/storefront/editor/utils/pages';
import { slugify } from 'utils';

import './page-add.scss';

const MODAL_WIDTH = 760;
const PAGE_DESCRIPTION_ROWS = 5;
const SLUG_DEBOUNCE_DELAY = 700;

export default class StorefrontEditorPageAdd extends React.PureComponent {
  static propTypes = {
    pages: pt.shape({
      templates: pt.array,
      pages: pt.array,
    }),
    onSubmit: pt.func,
    onClose: pt.func,
  };

  state = {
    saving: false,
    slug: null,
    errors: {},
  };

  setError(field, error) {
    this.setState({ errors: { ...this.state.errors, [field]: error } });
  }

  clearError(field) {
    this.setError(field, null);
  }

  getAllPages() {
    const { templates, pages } = this.props.pages;

    return [...templates, ...pages];
  }

  isLabelValid(label) {
    const pages = this.getAllPages();
    const page = findPage(pages, 'label', label);

    return !page;
  }

  isUrlValid(url) {
    const pages = this.getAllPages();
    const page = findPage(pages, 'url', url);

    return !page;
  }

  onChangeLabel = (event, value) => {
    const label = value.trim();

    this.onChangeSlug(null, label);

    if (!label) {
      return false;
    }

    if (!this.isLabelValid(label)) {
      return this.setError(
        'label',
        `A page with the title '${label}' already exists`,
      );
    }

    this.clearError('label');
  };

  onChangeSlug = debounce((event, value) => {
    const slug = slugify(value.trim());

    if (!slug) {
      return this.setState({ slug: null });
    } else {
      this.setState({ slug });
    }

    const url = getPageUrl(slug);

    if (!this.isUrlValid(url)) {
      return this.setError(
        'url',
        `A page with the url '${url}' already exists`,
      );
    }

    this.clearError('url');
  }, SLUG_DEBOUNCE_DELAY);

  onSubmit = async (values) => {
    const { onSubmit, onClose } = this.props;

    this.setState({ saving: true });

    const result = await onSubmit(values);

    if (result) {
      onClose();
    }

    this.setState({ saving: false });
  };

  render() {
    const { onClose } = this.props;
    const { saving, slug, errors } = this.state;

    return (
      <Form onSubmit={this.onSubmit} autoFocus={true}>
        <Modal
          className="storefront-editor--page-add--modal"
          title="New page"
          actions={[
            {
              label: 'Save page',
              type: 'submit',
            },
          ]}
          loading={saving}
          width={MODAL_WIDTH}
          onClose={onClose}
        >
          <fieldset>
            <div className="row">
              <Field
                className="span4"
                type="text"
                name="label"
                label="Title"
                onChange={this.onChangeLabel}
                error={errors.label}
                required={true}
              />
            </div>
            <div className="row">
              <Field
                className="span4 storefront-editor--page-add--url-field"
                type="text"
                name="slug"
                label="URL"
                value={slug}
                onChange={this.onChangeSlug}
                error={errors.url}
                required={true}
              />
            </div>
            <div className="row">
              <Field
                className="span4"
                type="textarea"
                name="description"
                label="Description"
                rows={PAGE_DESCRIPTION_ROWS}
                autoSize={true}
              />
            </div>
          </fieldset>
        </Modal>
      </Form>
    );
  }
}
